import React, { useState, useEffect } from 'react'
import SubBanner from '../component/SubBanner'  
import { Row, Col, Tabs, Tab } from 'react-bootstrap';
import PersonalInfo from '../component/PersonalInfo';
import PaymentInfoComp from '../component/PaymentInfoComp';
import MyServicesComp from '../component/MyServicesComp';
import Header from '../component/Header';
import SidebarBtn from '../assets/images/sidebar-icon.svg'
import CloseIcon from '../assets/images/close-white.svg'
import classNames from 'classnames';
import '../scss/profile.scss'
import Footer from '../component/Footer';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { toast } from "react-toastify"; // Import toast

function MyAccount() {
  
  // Get the slug from the URL
  const { innerPage } = useParams();
  const [activeTab, setActiveTab] = useState('personalInfo');
  const [isVisible, setIsVisible] = useState(false);
  
  const { successMessage, errorMessage } = useSelector(
    (state) => state.user
  );

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  const personalInfoClick = () => {
    setActiveTab('personalInfo'); // Set the active tab
    setIsVisible(false); // Toggle visibility
  };  
  const myServicesClick = () => {
    setActiveTab('myServices'); // Set the active tab
    setIsVisible(false); // Toggle visibility
  }; 
  const paymentInfoClick = () => {
    setActiveTab('paymentInfo'); // Set the active tab
    setIsVisible(false); // Toggle visibility
  };

 

  useEffect(() =>{
    if(innerPage !== undefined){
      if(innerPage === "my-services"){
        setActiveTab('myServices');
      }else if(innerPage === "payment-info"){
        setActiveTab('paymentInfo');
      }else{
        setActiveTab('personalInfo');
      }
      setIsVisible(false);
    }else{
      setActiveTab('personalInfo');
      setIsVisible(false);
    }
  }, [innerPage])

  useEffect(() => {
    if(activeTab === "myServices"){
      window.history.replaceState(null, "", '/profile/my-services'); 
    }else if(activeTab === "paymentInfo"){
        window.history.replaceState(null, "", '/profile/payment-info'); 
    }else {
      window.history.replaceState(null, "", '/profile'); 
    }
  }, [activeTab]);

 
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage, { autoClose: 3000, hideProgressBar: true });
    }
    if (errorMessage) {
      toast.error(errorMessage, { autoClose: 3000, hideProgressBar: true });
    }
  }, [successMessage, errorMessage]);

  return (
    <>
      <Helmet>
        <title>My Account | Helpotani</title>
        <meta name="description" content="" />
        <meta name="keywords" content="" />
      </Helmet>

      <div className='main profile-page'>
        <Header />
        <SubBanner HeaderTitle="My Account" HeaderSubtitle=""/> 
        <div className="profile-main">
         <div className='profile-main-wrap'>
         <Row>
            <Col lg={4} xl={3}>
              <div className={classNames("profile-sidebar ", { "filter-box--visible": isVisible })}>               
                <ul>
                  <li>
                    <Link to='#' onClick={personalInfoClick} className={activeTab === 'personalInfo' ? 'active' : ''}>
                      <svg className='stroke-svg' width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="6.5" r="4" strokeWidth="1.5"/>
                        <ellipse cx="12" cy="17.5" rx="7" ry="4" strokeWidth="1.5"/>
                      </svg>
                      Personal Information
                    </Link>
                  </li>
                  <li>
                    <Link to='#' onClick={myServicesClick} className={activeTab === 'myServices' ? 'active' : ''}>
                    <svg className='stroke-svg' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.5777 3.38197L17.5777 4.43152C19.7294 5.56066 20.8052 6.12523 21.4026 7.13974C22 8.15425 22 9.41667 22 11.9415V12.0585C22 14.5833 22 15.8458 21.4026 16.8603C20.8052 17.8748 19.7294 18.4393 17.5777 19.5685L15.5777 20.618C13.8221 21.5393 12.9443 22 12 22C11.0557 22 10.1779 21.5393 8.42229 20.618L6.42229 19.5685C4.27063 18.4393 3.19479 17.8748 2.5974 16.8603C2 15.8458 2 14.5833 2 12.0585V11.9415C2 9.41667 2 8.15425 2.5974 7.13974C3.19479 6.12523 4.27063 5.56066 6.42229 4.43152L8.42229 3.38197C10.1779 2.46066 11.0557 2 12 2C12.9443 2 13.8221 2.46066 15.5777 3.38197Z" strokeWidth="1.5" strokeLinecap="round"/>
                      <path d="M21 7.5L17 9.5M12 12L3 7.5M12 12V21.5M12 12C12 12 14.7426 10.6287 16.5 9.75C16.6953 9.65237 17 9.5 17 9.5M17 9.5V13M17 9.5L7.5 4.5" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                      My Services
                    </Link>
                  </li>
                  <li>
                    <Link to='#' onClick={paymentInfoClick} className={activeTab === 'paymentInfo' ? 'active' : ''}>
                      <svg className='stroke-svg' width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 12.5C2 8.72876 2 6.84315 3.17157 5.67157C4.34315 4.5 6.22876 4.5 10 4.5H14C17.7712 4.5 19.6569 4.5 20.8284 5.67157C22 6.84315 22 8.72876 22 12.5C22 16.2712 22 18.1569 20.8284 19.3284C19.6569 20.5 17.7712 20.5 14 20.5H10C6.22876 20.5 4.34315 20.5 3.17157 19.3284C2 18.1569 2 16.2712 2 12.5Z" strokeWidth="1.5"/>
                        <path d="M10 16.5H6" strokeWidth="1.5" strokeLinecap="round"/>
                        <path d="M14 16.5H12.5" strokeWidth="1.5" strokeLinecap="round"/>
                        <path d="M2 10.5L22 10.5" strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                      Payment Info
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={8} xl={9}>
              <div className="profile-content">
                <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} id="profile-tabs">
                  <Tab eventKey="personalInfo" title="Personal Information"> 
                    <div className='personal-information'>                                       
                      <PersonalInfo />
                    </div>
                  </Tab>  
                  <Tab eventKey="myServices" title="My Services">                    
                    <div className='my-services'>
                    <MyServicesComp />
                    </div>
                  </Tab>                
                  <Tab eventKey="paymentInfo" title="Payment Info">                    
                    <div className='payment-info'>
                      <PaymentInfoComp />
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </Col>
          </Row>
         </div>
        </div>
        <Link onClick={toggleVisibility} className="sidebar-bttn"><img src={isVisible ? CloseIcon : SidebarBtn} alt="" /></Link>
      </div>
      <Footer />
    </>
  )
}
export default MyAccount


